export const pxToRem = (px) => `${px / 10}rem`;
